import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;
declare const isClientTreez: string;

export interface TzProgressChannelData {
    message: string;
    progress: number;
    inProgress: boolean;
    success: boolean;
    syncType?: string | number;
}

class TzProgressUpdate {
    tzProgressUpdateChannel: any;

    constructor() {
        var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;
        var isClientTreezz = (typeof isClientTreez === "undefined") ? false : isClientTreez;

        if(isClientTreezz == 'true'){
            this.tzProgressUpdateChannel = App.cable.subscriptions.create(
                {
                    channel: "Treez::SyncProgressChannel",
                    tenant_code: x,
                    roomId: `tz_sync_${x}`
                },
                {
                    connected() {
                        console.log("Connected to Treez Progress Update Channel");
                    },
                    disconnected() {
                        console.log("Disconnected to Treez Progress Update Channel");
                    },
                    received: (data: any) => this.updateProgress(data)
                }
            );
        }
    }

    updateProgress(data: TzProgressChannelData) {
        console.log(data);
        if (this.isQuantitiesDownload(data)) {
            this.updateQuantitiesProgress(data);
            return;
        }
        if (data.syncType && data.syncType !== "catalog") {
            return;
        }

        this.updateCatalogProgress(data);
    }

    isQuantitiesDownload(data: TzProgressChannelData): boolean {
        return data.syncType === "inventory_download" || data.syncType === 2;
    }

    updateCatalogProgress(data: TzProgressChannelData) {
        const progress = data.progress ?? 0;
        const $treezSync = $("#treez_sync");
        if (!$treezSync.length) {
            return;
        }

        if (data.inProgress) {
            $treezSync.show();
            $("#treez_sync_btn").hide();
            $("#last_update").hide();
            $("#tz_sync_progress").text(data.message);
            $treezSync.find(".progress-bar").css("width", `${progress}%`);
            $("#progressLabel").text(`${progress}%`);
            return;
        }

        $treezSync.hide();
        $("#treez_sync_btn").show();
        $("#last_update").show();
        this.refresh();
    }

    updateQuantitiesProgress(data: TzProgressChannelData) {
        const progress = data.progress ?? 0;
        const $treezQtySync = $("#treez_qty_sync");
        if (!$treezQtySync.length) {
            return;
        }

        if (data.inProgress) {
            $treezQtySync.show();
            $("#tz_qty_sync_progress").text(data.message);
            $treezQtySync.find(".treez-qty-progress-bar").css("width", `${progress}%`);
            $("#treezQtyProgressLabel").text(`${progress}%`);
            return;
        }

        $treezQtySync.hide();
        this.refresh();
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("items", () => {
        const ts = new TzProgressUpdate();
    });
    InitPage("print_v2", () => {
        const t = new TzProgressUpdate();
    });
    InitPage("compare_v2", () => {
        const t = new TzProgressUpdate();
    });
}
